import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import classNames from "classnames";

import { Title } from "../../common/Title";
import { TitleLine } from "./TitleLine";
// import { MorphSvg } from "../../common/MorphSvg";

import { ReactComponent as UALLogo } from "../../../images/ual-logo.svg";
import styles from "./Home.module.scss";
import { MorphPaths } from "../../common/MorphSvg/paths";
import { HomeMorph } from "./HomeMorph";
import { useAppContext } from "../../Context/AppContext";

const HomePage: React.FC = () => {
  const { animating } = useAppContext();
  const [active, setActive] = useState(false);
  const [animation, setAnimation] = useState(false);

  useEffect(() => {
    if (!animating) {
      requestAnimationFrame(() => {
        setActive(true);
      });

      const timer = setTimeout(() => {
        setAnimation(true);
      }, 250);

      return () => clearTimeout(timer);
    }
  }, [animating]);

  return (
    <section
      className={classNames(
        styles.home,
        { [styles.active]: active },
        { [styles.animate]: animation }
      )}
    >
      <UALLogo className={styles.leadLogo} />

      <div className={styles.content}>
        <h1 className={styles.title}>
          <TitleLine text="Creativé" />
          <br />
          <TitleLine text="Elеphаnṭ" />
        </h1>

        <Title className={styles.tagline} tagName="p" stable>
          Celebrating the arts and creativity
          <br />
          in this diverse Southwark & Lambeth community.
        </Title>

        <Link to="/map" className={`${styles.cta} std-button`}>
          Enter Site
        </Link>

        <HomeMorph
          morphObject={MorphPaths.Museum}
          className={classNames(styles.decoration, styles.decorationMuseum)}
          morph
        />

        <HomeMorph
          morphObject={MorphPaths.Discussion}
          className={classNames(styles.decoration, styles.decorationDiscussion)}
        />

        <HomeMorph
          morphObject={MorphPaths.Jump}
          className={classNames(styles.decoration, styles.decorationJump)}
          morph
        />

        <HomeMorph
          morphObject={MorphPaths.Acting}
          className={classNames(styles.decoration, styles.decorationActing)}
        />

        <HomeMorph
          morphObject={MorphPaths.Castle}
          className={classNames(styles.decoration, styles.decorationCastle)}
          morph
        />

        <HomeMorph
          morphObject={MorphPaths.Events}
          className={classNames(styles.decoration, styles.decorationEvents)}
        />

        <HomeMorph
          morphObject={MorphPaths.Brewery}
          className={classNames(styles.decoration, styles.decorationBrewery)}
        />

        <HomeMorph
          morphObject={MorphPaths.Elephant}
          className={classNames(styles.decoration, styles.decorationElephant)}
          morph
        />

        <HomeMorph
          morphObject={MorphPaths.LiveMusic}
          className={classNames(styles.decoration, styles.decorationLiveMusic)}
        />

        <HomeMorph
          morphObject={MorphPaths.Performance}
          morph
          className={classNames(
            styles.decoration,
            styles.decorationPerformance
          )}
        />

        <HomeMorph
          morphObject={MorphPaths.Radio}
          className={classNames(styles.decoration, styles.decorationRadio)}
        />

        <HomeMorph
          morphObject={MorphPaths.Art}
          className={classNames(styles.decoration, styles.decorationArt)}
        />

        {/* <HomeMorph
          morphObject={MorphPaths.LiveMusic}
          className={classNames(styles.decoration, styles.decorationLiveMusic)}
        />

        <HomeMorph
          morphObject={MorphPaths.Radio}
          className={classNames(styles.decoration, styles.decorationRadio)}
        />

        <HomeMorph
          morphObject={MorphPaths.Elephant}
          className={classNames(styles.decoration, styles.decorationElephant)}
        />

        <HomeMorph
          morphObject={MorphPaths.Gallery}
          className={classNames(styles.decoration, styles.decorationGallery)}
        />

        <HomeMorph
          morphObject={MorphPaths.Performance}
          className={classNames(
            styles.decoration,
            styles.decorationPerformance
          )}
        />

        <HomeMorph
          morphObject={MorphPaths.Bars}
          className={classNames(styles.decoration, styles.decorationBars)}
        />

        <HomeMorph
          morphObject={MorphPaths.Brewery}
          className={classNames(styles.decoration, styles.decorationBrewery)}
        />

        <HomeMorph
          morphObject={MorphPaths.CreativeSpaces}
          className={classNames(
            styles.decoration,
            styles.decorationCreativeSpaces
          )}
        /> */}
      </div>
    </section>
  );
};

export { HomePage };
